import { Column, Expaned, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import DataDateSelect, { scopeTypeMap } from '../components/data-date-select/data-date-select'
import './good-sale.scss'
import classnames from 'classnames'
import { useRequest, useUpdateEffect } from 'ahooks'
import { $post } from '@/api'
import { AutoResizer, isNoMore, WithScrollLoad } from '@/utils/utils-widget'
import { errorCallBack, get } from '@/utils'
import { useMemo } from 'react'
import { IPagination } from '@/model/types/common'
import { GoodSaleByCategory, GoodSaleByGroup, GoodSaleByName } from './type'
import { useCallback } from 'react'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import { ColumnsType } from 'antd/lib/table'
import { Table } from 'antd'
import GoodSaleChart from './good-sale-chart/good-sale-chart'
import GoodSaleAmountChart from './good-sale-chart/good-amount-chart'
import Iconfont from '@/components/iconfont/iconfont'
import GoodSaleFilter from './good-sale-filter/good-sale-filter'
import { layerManage, showLayer } from '@/utils/layer'
import GoodSaleSearch from './good-sale-search/good-sale-search'
import { GoodsDetail } from '../../goods-manage/goods-storage/goods-library/modules/goods-detail/goods-detail'
import { goodSaleFilterStore } from './good-sale-filter/store'
import { observer } from 'mobx-react'
import { useShowShadow } from '../account-checking/account-checking'

const goodTypeMap = ['商品名称', '商品类目', '商品分组']

const GoodSale = observer(() => {
    const cls = useBemClass('good-sale')
    const [type, setType] = useState<number>(0) // 0 商品名称 1 商品类目 2 商品分组
    const [date, setDate] = useState<(string | undefined)[]>([
        dayjs().format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
    ])
    const [scope, setScope] = useState<number>(0)

    // 表格排序方式 "0": "按商品 ID 排序", "1": "按类目 ID 排序", "2": "有效销售金额排序", "3": "按销售笔数排序", "4": "按销售量排序"
    const [sortKey, setSortKey] = useState<Array<string | undefined>>(Array(3).fill(undefined))
    const [sortType, setSortType] = useState<Array<boolean | undefined>>(Array(3).fill(undefined)) // true 降序 false 升序 undefind 无

    const [sumSales, setSumSales] = useState<number>(0) // 总销售额
    const [sumAmount, setSumAmount] = useState<number>(0) // 总销售笔数

    const [tip, setTip] = useState<string>('当前展示当日数据')
    const [showTip, setShowTip] = useState<boolean>(true)

    const setAllData = useSetDataTogether()

    const { onScroll: scrollRun, showShadow } = useShowShadow()

    const handleParams = useMemo(() => {
        return {
            limit: 30,
            from_date: date[0],
            ordering_type: sortKey[type],
            ordering_desc: sortType[type],
            to_date: date[1],
        }
    }, [date, sortKey, sortType, type])

    const onHanlderSuccess = useCallback(
        (res: { sum_net_sales_income: number; sum_net_order_count: number }) => {
            setAllData(() => {
                setSumSales(res.sum_net_sales_income)
                setSumAmount(res.sum_net_order_count)
            })
        },
        [setAllData],
    )

    const groupRequestHandle = useRequest<
        {
            list: GoodSaleByGroup.GoodsTableList[]
            pagination: IPagination
            sum_net_sales_income: number
            sum_net_order_count: number
        },
        GoodSaleByGroup.Data
    >(
        val => {
            return $post({
                url: '/finance/getgoodssalesstatisticsbygroup',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    ...handleParams,
                    ...goodSaleFilterStore.goodGroupFilterQuery,
                },
            })
        },
        {
            loadMore: true,
            isNoMore: isNoMore,
            onSuccess: onHanlderSuccess,
            manual: true,
            formatResult: data => {
                return {
                    ...data,
                    list: data.goods_data_list.map(data => ({
                        ...data,
                        children: data.secondary_group_list.map(second => ({
                            ...second,
                            group_name: second.secondary_group_name,
                            group_id: second.secondary_group_id,
                        })),
                    })),
                    pagination: {
                        limit: 30,
                        page: 1,
                        page_count: 1,
                    },
                }
            },
            onError: errorCallBack,
        },
    )

    const categoryRequestHandle = useRequest<
        {
            list: GoodSaleByCategory.GoodsDataList[]
            pagination: IPagination
            sum_net_sales_income: number
            sum_net_order_count: number
        },
        GoodSaleByCategory.Data
    >(
        val => {
            return $post({
                url: '/finance/getgoodssalesstatisticsbycategory',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    ...handleParams,
                    ...goodSaleFilterStore.goodCategoryFilterQuery,
                },
            })
        },
        {
            loadMore: true,
            isNoMore: isNoMore,
            onSuccess: onHanlderSuccess,
            manual: true,
            formatResult: data => {
                return {
                    ...data,
                    list: data.goods_data_list,
                    pagination: data.pagination,
                }
            },
            onError: errorCallBack,
        },
    )

    const nameRequestHandle = useRequest<
        {
            list: GoodSaleByName.GoodsDataList[]
            pagination: IPagination
            sum_net_sales_income: number
            sum_net_order_count: number
        },
        GoodSaleByName.Data
    >(
        val => {
            return $post({
                url: '/finance/getgoodssalesstatistics',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    ...handleParams,
                    ...goodSaleFilterStore.goodNameFilterQuery,
                },
            })
        },
        {
            loadMore: true,
            isNoMore: isNoMore,
            manual: true,
            onSuccess: onHanlderSuccess,
            formatResult: data => {
                return {
                    ...data,
                    list: data.goods_data_list,
                    pagination: data.pagination,
                }
            },
            onError: errorCallBack,
        },
    )

    const commomColumns: (key: string) => ColumnsType<any> = useCallback((key: string) => {
        return [
            {
                dataIndex: 'net_order_count',
                title: '销售笔数',
                align: 'right',
                key: key + 'net_order_count',
                width: 140,
                sorter: true,
            },
            {
                dataIndex: 'net_sales_weight',
                title: '重量',
                align: 'right',
                key: key + 'net_sales_weight',
                width: 140,
                sorter: true,
            },
            {
                dataIndex: 'net_sales_number',
                title: '数量',
                align: 'right',
                key: key + 'net_sales_number',
                width: 140,
                sorter: true,
            },
            {
                dataIndex: 'net_sales_income',
                key: key + 'net_sales_income',
                title: '销售额',
                align: 'right',
                width: 140,
                sorter: true,
                render: (v, r) => `${v}元`,
            },
        ]
    }, [])

    const goodNameColumns: ColumnsType<GoodSaleByName.GoodsDataList> = [
        {
            title: '#',
            width: 40,
            align: 'center',
            render: (v, r, i) => i + 1,
        },
        {
            title: (
                <Row
                    data-padding-right-6
                    data-width-100p
                    data-aling-items-center
                    data-justify-content-space-between
                    data-cursor-pointer
                    onClick={() => {
                        showLayer(<GoodSaleSearch date={date} />)
                    }}
                >
                    <div>商品名称</div>
                    <Iconfont name="icon6sousuo999-20" size={16} />
                </Row>
            ),
            render: (v, r, i) => (
                <Column>
                    <div data-color-000 data-font-size-14>
                        {r.goods.name}
                    </div>
                    <Row data-align-items-center data-margin-top-4>
                        <div data-color-999 data-font-size-12>
                            {[
                                r.unit_ratio !== 1
                                    ? `1${r.sales_unit_name}=${r.unit_ratio}${r.goods.stock_unit.name}`
                                    : '',
                                r.price_annotation,
                            ]
                                .filter(Boolean)
                                .join(';')}
                        </div>
                    </Row>
                </Column>
            ),
        },
        {
            dataIndex: 'net_order_count',
            key: 'name_net_order_count',
            title: '销售笔数',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}单`,
        },
        {
            dataIndex: 'net_sales_count',
            key: 'name_net_sales_count',
            title: '销售量',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}${r.sales_unit_name}`,
        },
        {
            dataIndex: 'net_sales_income',
            key: 'name_net_sales_income',
            title: '销售额',
            align: 'right',
            width: 140,
            sorter: true,
            render: (v, r) => `${v}元`,
        },
        {
            title: '操作',
            width: 96,
            fixed: 'right',
            align: 'center',
            render: (val, record) => (
                <div
                    className="action"
                    onClick={() => {
                        showLayer(<GoodsDetail goodsId={record.goods.id} />)
                    }}
                >
                    详情
                </div>
            ),
        },
    ]

    const goodCategroyColumns: ColumnsType<GoodSaleByCategory.GoodsDataList> = [
        {
            title: '#',
            width: 40,
            align: 'center',
            render: (v, r, i) => i + 1,
        },
        {
            title: '商品类目',
            dataIndex: 'category_name',
        },
        ...commomColumns('category'),
        {
            title: '操作',
            width: 96,
            align: 'center',
            render: (v, r) => (
                <div
                    className="action"
                    onClick={() => {
                        setType(0)
                        goodSaleFilterStore.setCategory([
                            {
                                id: r.category_id,
                                name: r.category_name,
                                img_url: '',
                                group_name: '',
                                secondary_group_name: '',
                            },
                        ])
                    }}
                >
                    详情
                </div>
            ),
        },
    ]

    const goodGroupColumns: ColumnsType<GoodSaleByGroup.GoodsTableList> = [
        {
            title: '#',
            width: 40,
            align: 'center',
            render: (v, r, i) => i + 1,
        },
        {
            title: '上架范围',
            key: 'is_mall_group',
            dataIndex: 'is_mall_group',
            width: 80,
            render: val => (
                <Row>
                    <Iconfont name="icon2shangjiaweishangcheng" size={20} />
                    {val && (
                        <Iconfont
                            name="icon2shangjiashouyintai"
                            size={20}
                            style={{
                                marginLeft: '8px',
                            }}
                        />
                    )}
                </Row>
            ),
        },
        {
            title: '分组名',
            align: 'left',
            dataIndex: 'group_name',
        },
        ...commomColumns('group'),
        {
            title: '操作',
            width: 96,
            align: 'center',
            render: (v, r) => (
                <div
                    className="action"
                    onClick={() => {
                        setType(0)
                        goodSaleFilterStore.setGroupName([r.group_name])
                        // @ts-ignore
                        if (r.secondary_group_id) {
                            if (r.is_mall_group) {
                                goodSaleFilterStore.setSecondGroup([`_${r.group_id}`])
                            } else {
                                goodSaleFilterStore.setSecondGroup([r.group_id])
                            }
                        } else {
                            if (r.is_mall_group) {
                                goodSaleFilterStore.setGroup([`_${r.group_id}`])
                            } else {
                                goodSaleFilterStore.setGroup([r.group_id])
                            }
                        }
                    }}
                >
                    详情
                </div>
            ),
        },
    ]

    const handleList = [nameRequestHandle, categoryRequestHandle, groupRequestHandle]
    const columnList = [goodNameColumns, goodCategroyColumns, goodGroupColumns]
    const filterTextMap = [
        goodSaleFilterStore.filterText,
        goodSaleFilterStore.filterCategroyText,
        goodSaleFilterStore.filterGroupText,
    ]
    const tableKeys = ['pricing_method_id', 'category_id', 'group_id']

    useEffect(() => {
        handleList[type].run()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    useUpdateEffect(() => {
        handleList[type].reload()
    }, [handleParams, goodSaleFilterStore.goodNameFilterQuery])

    const setSortParams = useCallback(
        (sorter: any) => {
            const sortKeyNameMap: Record<string, string> = {
                net_order_count: '3',
                net_sales_count: '4',
                net_sales_income: '2',
            }
            const sortKeyCategoryMap: Record<string, string> = {
                net_order_count: '0',
                net_sales_number: '1',
                net_sales_weight: '2',
                net_sales_income: '3',
            }
            setAllData(() => {
                setSortKey(key => {
                    const tmp = key.slice()
                    tmp[type] = type === 0 ? sortKeyNameMap[sorter.field] : sortKeyCategoryMap[sorter.field]

                    return tmp
                })
                setSortType(t => {
                    const tmp = t.slice()
                    tmp[type] = sorter.order === void 0 ? void 0 : sorter.order === 'descend'

                    return tmp
                })
            })
        },
        [setAllData, type],
    )

    return (
        <Expaned className={cls()}>
            <Expaned data-column data-overflow-hidden className={cls('content')}>
                <Row
                    className={classnames({
                        [cls('shadow')]: showShadow,
                    })}
                    data-padding-bottom-10
                    data-align-items-center
                    data-margin-top-16
                    data-justify-content-space-between
                >
                    <Row data-align-items-center>
                        <Row data-margin-right-16>
                            {goodTypeMap.map((s, index) => (
                                <div
                                    className={classnames(cls('tab'), {
                                        [cls('tab-active')]: index === type,
                                    })}
                                    key={s}
                                    onClick={() => {
                                        setType(index)
                                        if (filterTextMap[type]) {
                                            goodSaleFilterStore.reset()
                                        }
                                    }}
                                >
                                    {s}
                                </div>
                            ))}
                        </Row>
                        <DataDateSelect
                            day={0}
                            month={0}
                            year={0}
                            week={0}
                            type="data"
                            onClick={(from, to, scope, t) => {
                                setAllData(() => {
                                    setDate([from, to])
                                    setScope(scope)
                                    setTip(t)
                                    setShowTip(true)
                                })
                            }}
                        />
                    </Row>
                    <Row data-align-items-center>
                        <div hidden={!showTip} data-color-999 data-font-size-14 data-margin-right-10>
                            {tip}
                        </div>
                        <div className="time-picker">
                            <DatePicker.RangePicker
                                allowClear={false}
                                picker={scopeTypeMap[scope] as any}
                                dateRender={current => (
                                    <div
                                        className="ant-picker-cell-inner"
                                        style={{
                                            borderRadius: '50%',
                                        }}
                                    >
                                        {current.date()}
                                    </div>
                                )}
                                value={[moment(date[0]), moment(date[1])]}
                                onChange={(monent, dateString) => {
                                    if (monent) {
                                        setShowTip(false)
                                        if (scopeTypeMap[scope] === 'month') {
                                            if (!monent) return
                                            const start_date = monent[0]?.format('YYYY-MM-DD')
                                            const end_date = monent[1]
                                                ?.set('date', 1)
                                                .add(1, 'month')
                                                .subtract(1, 'days')
                                                .format('YYYY-MM-DD') // 取这个月最后一天
                                            setDate([start_date, end_date])
                                        } else if (scopeTypeMap[scope] === 'year') {
                                            const start_date = monent[0]?.format('YYYY-MM-DD')
                                            const end_date = monent[1]
                                                ?.add(1, 'year')
                                                .set('date', 1)
                                                .set('month', 0)
                                                .subtract(1, 'days')
                                                .format('YYYY-MM-DD') // 去这一年最后一天
                                            setDate([start_date, end_date])
                                        } else {
                                            monent[0] && setDate(monent?.map(m => m?.format('YYYY-MM-DD')))
                                        }
                                    }
                                }}
                                suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                            />
                        </div>
                        <div
                            className={cls('filter')}
                            data-cursor-pointer
                            onClick={() => {
                                showLayer(
                                    <GoodSaleFilter
                                        type={type}
                                        onClick={() => {
                                            layerManage.pop()
                                        }}
                                    />,
                                )
                            }}
                            style={{
                                color: !filterTextMap[type] ? '#333' : '#14cc9b',
                            }}
                        >
                            <i className="iconfont icon6shaixuan-20" data-font-size-20 />
                            <span data-margin-left-8>筛选</span>
                        </div>
                    </Row>
                </Row>

                {!!filterTextMap[type] && (
                    <Row className={cls('searchBox')}>
                        <div>
                            筛选：
                            <span className="them-color" data-font-weight-600 data-padding-h-8>
                                {filterTextMap[type]}
                            </span>
                        </div>
                        <div
                            className={cls('delete')}
                            onClick={() => {
                                goodSaleFilterStore.reset()
                            }}
                        >
                            <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                        </div>
                    </Row>
                )}

                <Expaned data-column data-overflow-auto className={cls('no-scroll')} onScroll={scrollRun}>
                    <Row>
                        <GoodSaleChart type={type} saleAmount={sumSales} date={date} />
                        <GoodSaleAmountChart type={type} saleAmount={sumAmount} date={date} />
                    </Row>

                    <AutoResizer>
                        {({ height }) => {
                            return (
                                <div className={cls('table-container')}>
                                    <WithScrollLoad
                                        data-height-100p
                                        data-overflow-hidden
                                        scrollloadhandle={handleList[type]}
                                    >
                                        <Table
                                            rowKey={record =>
                                                `${type === 0 ? get(record, 'sale_scene', '') : ''}${get(
                                                    record,
                                                    tableKeys[type],
                                                    '',
                                                )}`
                                            }
                                            loading={handleList[type].loading || handleList[type].loadingMore || void 0}
                                            bordered
                                            defaultExpandAllRows
                                            expandRowByClick
                                            pagination={false}
                                            onChange={(page, filter, sorter) => {
                                                setSortParams(sorter)
                                            }}
                                            columns={columnList[type] as any}
                                            dataSource={(handleList[type] as any).data?.list}
                                            scroll={{ x: 'max-content', y: height - 50 }}
                                        />
                                    </WithScrollLoad>
                                </div>
                            )
                        }}
                    </AutoResizer>
                </Expaned>
            </Expaned>
        </Expaned>
    )
})

export default GoodSale
